export default __webpack_public_path__ + "static/Answer, summarise, prioritise-394a79de730b6593587f323c79b0ac34.png";